.container {
  display: flex;
  flex-direction: column;
  height: 100vh;
  overflow: hidden;
}

.controlArea {
  flex: 2;
  display: flex;
  flex-direction: row-reverse;
  align-items: center;
  gap: 8px;
  padding: 5px 12.5px 5px 5px;
  min-width: 150px;
}

.profileDisplay {
  display: flex;
  align-items: center;
  gap: 3px;
  color: white;
  font-size: 14px;
  width: 140px;
  flex-shrink: 0;
}

.profileIcon {
  font-size: 18px;
  flex-shrink: 0;
  width: 18px;
}

.profileName {
  font-weight: 500;
  white-space: nowrap;
  flex: 1;
  min-width: 0;
}

.statusMessageArea {
  flex: 0;
  padding: 4px 0;
}

.flexRow {
  display: flex;
  flex-direction: row;
}

.alignCenter {
  align-items: center;
}

.justifyCenter {
  justify-content: center;
}

.statusMessage {
  padding: 2px 8px;
}

.p2 {
  padding: 0.5rem;
}

.mainContent {
  flex: 9;
  display: flex;
  flex-direction: row;
  overflow: hidden;
  position: relative;
  z-index: 0;
}

.sidebarArea {
  width: 280px;
  min-width: 280px;
  background-color: var(--bads-color-background-surface, #fafbfc);
  border-right: 1px solid var(--bads-color-border-subtle, #d1d9e0);
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  padding: 1rem;
}

.sidebarHeader {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 16px;
  font-weight: 600;
  color: var(--bads-color-text-primary, #1a1a1a);
  margin-bottom: 1.5rem;
  padding-bottom: 0.5rem;
  border-bottom: 1px solid var(--bads-color-border-subtle, #d1d9e0);
}

.contentArea {
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: auto;
  min-width: 0;
  margin-left: 10px;
}

.errorContent {
  flex: 9;
  display: flex;
  flex-direction: column;
  align-items: center;
  overflow-y: auto;
  overflow-x: hidden;
}

.planningViewArea {
  flex: 14;
  border-radius: 0.3rem;
  padding: 0 12.5px 0 12.5px;
  display: flex;
  flex-direction: column;
  min-height: 0;
}

.footer {
  flex: 0.5;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0.5rem;
  flex-direction: row;
  column-gap: 1rem;
  border-top: 1px solid rgba(209, 217, 224, 0.7);
  position: relative;
  flex-shrink: 0;
}

bads-notification-toast-v1 {
  position: relative;
  z-index: 100000;
}

.selectionDisplay {
  display: flex;
  align-items: center;
  padding: 8px 12px;
  background-color: var(--bads-color-secondary-20);
  border: 1px solid var(--bads-color-secondary-40);
  border-radius: 6px;
  position: absolute;
  right: 0.7rem;
  top: 50%;
  transform: translateY(-50%);
}

.selectionInfo {
  color: var(--bads-color-secondary-90);
  font-size: 13px;
  font-weight: 500;
}
